module.exports = __webpack_public_path__ + "static/img/pin.2943ead.svg";